/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */

/**
 * Silences console output in production builds. Imported first in index.js so
 * it runs before any other module. This covers our own logs and the ones in
 * bundled packages, e.g. borrower-lead-generation-tool logs full axios errors
 * on failed requests, which include the visitor's name, email and phone.
 *
 * The .babelrc remove-console plugin does not apply: react-scripts builds
 * ignore .babelrc.
 */
if (process.env.NODE_ENV === "production") {
  const noop = () => {};
  ["log", "info", "debug", "warn", "error", "table", "dir", "trace"].forEach(
    (method) => {
      // eslint-disable-next-line no-console
      console[method] = noop;
    }
  );
}
